<template>
    <div>

        <div class="profile-pets">
            <div class="profile-pets__content">

                <div class="profile-pets__body">

                    <div class="profile-pets__header" v-text="filter.title"></div>

                    <template v-if="!loading">
                        <div class="profile-pets__body-content d-flex" v-if="list.length">
                            <profile-pet :type="request.type" v-for="(item, index) in list" :pet="item" :key="index"/>
                        </div>
                        <div class="profile-pets__body-content d-flex empty-list" v-else>
                            {{$store.getters.t('organizations_projects_empty')}}
                        </div>
                    </template>
                    <template v-else>
                        <div class="profile-pets__body-content profile-pets__body-content d-flex">
                            <div class="LoaderBalls">
                                <div class="LoaderBalls__item"></div>
                                <div class="LoaderBalls__item"></div>
                                <div class="LoaderBalls__item"></div>
                            </div>
                        </div>
                    </template>


                </div>

            </div>
        </div>

        <div class="row" v-if="pageCount > 1">
            <div class="col-md-12">
                <div class="pagination-area pull-right">
                    <nav class="navigation pagination" role="navigation">
                        <div class="nav-links">
                            <paginate
                                v-model="page"
                                :page-count="pageCount"
                                :click-handler="paginateClickCallback"
                                :prev-text="''"
                                :next-text="''"
                                :container-class="'className'"
                                :page-class="'page-numbers'"
                                :page-link-class="''"
                                :active-class="'current'"
                                :prev-class="'prev page-numbers'"
                                :prev-link-class="'lnr lnr-arrow-left'"
                                :next-class="'next page-numbers'"
                                :next-link-class="'lnr lnr-arrow-right'"
                            >
                            </paginate>
                        </div>
                    </nav>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


import ProfilePet from './OrganizationProfilePet'

export default {
    name: "OrganizationProjects",
    components: {
        ProfilePet
    },
    data(){
        return{
            pageCount: 1,
            loading: false,
            page: 1,
            list: []
        }
    },

    props: ['filter', 'organization'],
    mounted() {

        this.getList(this.request.url, this.request.params, true)

    },

    computed:{


        request(){

            let req = {
                url: null,
                params: null,
                type: null
            }

            if(!this.filter.petsType && this.organization && this.organization.id) return this.list = []

            switch (this.filter.petsType){
                case 'actualProjects':

                    req = {
                        url: `/api/organizations/${this.organization.id}/supported-projects`,
                        params: {
                            status: 1,
                        },
                        type: 'projects'
                    }

                    break;
                case 'archivedProjects':

                    req = {
                        url: `/api/organizations/${this.organization.id}/supported-projects`,
                        params: {
                            status: 0
                        },
                        type: 'projects'
                    }

                    break;
                case 'membersPetsSelf':

                    req = {
                        url: `/api/organizations/${this.organization.id}/members-pets`,
                        params: {},
                        type: 'pets'

                    }

                    break;
                case 'membersPets':

                    req = {
                        url: `/api/organizations/${this.organization.id}/supported-pets`,
                        params: {
                            status: 1,
                        },
                        type: 'pets'

                    }

                    break;
                default:
                    req = {
                        url: `/api/organizations/${this.organization.id}/supported-projects`,
                        params: {
                            status: 1,
                        },
                        type: 'projects'

                    }

                    break;

            }

            return req

        }


    },

    methods: {

        getList(url, reqParams, reset = false){
            let params = {
                ...reqParams,
                per_page: 4,
                page: reset ? this.page = 1 : this.page
            };

            axios.get(url, {params: params})
                .then(response => {
                    response = response.data

                    if(response.success){

                        this.list = response.data

                        this.pageCount = response.meta.last_page


                    }

                })
                .catch(error => {
                    error = error.response.data

                    if(!error.success) console.log(error)

                })

        },

        paginateClickCallback(pageNum) {
            this.page = pageNum;

            this.getList(this.request.url, this.request.params, false)

        },
    },

    watch: {
        request(){
            this.getList(this.request.url, this.request.params, true)
        },

        list(){
            this.loading = true;
            setTimeout(()=>{
                this.loading = false
            },1000)
        },
    }


}
</script>

<style lang="scss" scoped>
.LoaderBalls {
    margin: 0 auto;
    width: 90px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__item {
        // .LoaderBalls__wrapper__item
        $anim-drt: 0.3s;
        $anim-ease: cubic-bezier(.6,.05,.15,.95);
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #2E76E4;

        &:nth-child(1) {
            animation: bouncing $anim-drt alternate infinite $anim-ease;
        }

        &:nth-child(2) {
            animation: bouncing $anim-drt $anim-drt/4 alternate infinite $anim-ease backwards;
        }

        &:nth-child(3) {
            animation: bouncing $anim-drt $anim-drt/2 alternate infinite $anim-ease backwards;
        }
    }
}


@keyframes bouncing {

    0% {
        transform: translate3d(0, 10px, 0) scale(1.2, 0.85);
    }

    100% {
        transform: translate3d(0, -20px, 0) scale(0.9, 1.1);
    }
}
</style>
